import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { toast } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useDeleteInstructor, useInstructorsQuery } from "../api/queries";
import { InstructorsFilter } from "../ui/instructors/InstructorsFilter";
import { InstructorsTable } from "../ui/instructors/InstructorsTable";
import { InstructorsToolbar } from "../ui/instructors/InstructorsToolbar";

export function InstructorsPage() {
  const nav = useNavigate({ from: "/app/master/instructors" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/master/instructors",
  });

  const list = useInstructorsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["master:create"]);
  const deleteInstructor = useDeleteInstructor();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຄູສອນ" },
          ]}
        />
      </Header>

      <Main>
        <InstructorsToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/master/instructors/create" })}
        />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <InstructorsFilter />

          <InstructorsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onViewProfile={(instructor) =>
              nav({
                to: "/app/master/instructors/$id",
                params: { id: instructor.id },
              })
            }
            onEdit={(instructor) =>
              nav({
                to: "/app/master/instructors/$id/edit",
                params: { id: instructor.id },
              })
            }
            onDelete={async (id) =>
              toast.promise(deleteInstructor.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບຄູສອນສຳເລັດ",
                error: "ລຶບຄູສອນລົ້ມເຫຼວ",
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
